import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { ClientIcon } from '~/modules/common/components/Icons';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(1)
  }
}));

export const ClientSuggestionItem = ({ option: { key } }) => {
  const classes = useStyles();

  return (
    <>
      <ClientIcon />
      <Typography
        variant="inherit"
        classes={{ root: classes.root }}
        color="inherit"
      >
        {key}
      </Typography>
    </>
  );
};

ClientSuggestionItem.propTypes = {
  option: PropTypes.object
};

export default ClientSuggestionItem;
